<template>
  <section class="container boxWithBorder">
    <ItineraryPieceBooking :sol="solutionAll" :key="solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key" class="ml-5 mr-5"/>
  </section>
</template>

<script>
  import ItineraryPieceBooking from "./ItineraryPieceBooking";
  import bookingMixin from "../../mixins/bookingMixin";
  
  export default {
    name: "Itinerary",
    mixins: [bookingMixin],
    components: {
      ItineraryPieceBooking,
    },
    data: function () {
      return {}
    },
    computed: {
    },
  }
</script>

<style scoped>
</style>